import React from 'react';

function Hero() {
  return (
    <div className="pt-0 pb-8 md:pb-12 space-y-8 -mt-4">

      {/* Hidden SEO Content - Visible to search engines but not users */}
      <div className="sr-only" aria-hidden="true">
        <h1>Eruhub Technologies - App Studio</h1>
        <h2>About Eruhub Technologies</h2>
        <p> We design and build applications that help more people learn, connect, and get things done.</p>
        <h2>Eruhub Technologies Keywords</h2>
        <p>Eruhub Technologies, mobile apps, web apps, software development, technology for access, inclusive software.</p>
      </div>

      {/* About Us Section */}
      <section>
        <div className="space-y-4 text-gray-300 leading-relaxed">
          <p>
            We design and build applications that matter, with a focus on using technology to increase access.
          </p>
          <p>
            Too often, good tools, information, and opportunities stay out of reach. We build software that helps level the playing field: apps that make it easier for more people to learn, to connect, and to get things done. Whether that means reaching underserved communities, simplifying complex workflows, or opening up services that used to be locked behind barriers, we're interested in work that expands who can participate.
          </p>
          <p>
            If you're building in this space or want to explore what's possible, <a href="mailto:team@eruhub.com?subject=Hello from Eruhub site&body=Hi team,%0D%0A%0D%0AI'd like to get in touch.%0D%0A%0D%0ABest regards" className="text-white font-bold underline hover:text-gray-300 transition-colors duration-300">get in touch</a>.
          </p>
        </div>
      </section>
    </div>
  );
}

export default Hero;